import React, { lazy } from 'react';
import { Switch } from 'react-router-dom';
import PrivateRoute from '../../components/PrivateRoute';
import retry from '../../retry';

const ProgramacaoPagamentosPage = lazy(() =>
  retry(() => import('./ProgramacaoPagamentosPage'))
);
const AulasAvulsasPage = lazy(() => retry(() => import('./AulasAvulsasPage')));
const RelatorioPage = lazy(() => retry(() => import('./RelatorioPage')));

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/programacao-pagamentos"
      component={ProgramacaoPagamentosPage}
    />
    <PrivateRoute
      exact
      path="/programacao-pagamentos/aulas-avulsas"
      component={AulasAvulsasPage}
    />
    <PrivateRoute
      exact
      path="/programacao-pagamentos/relatorio"
      component={RelatorioPage}
    />
  </Switch>
);
